import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@services/auth.service';
import { TourService } from '@services/tour/tour.service';

interface SidebarItem {
  title: string;
  icon: string;
  link?: string;
  action?: () => void;
  danger?: boolean;
}

@Component({
  selector: 'app-sidebar',
  standalone: false,
  
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent implements OnInit{
  sidebarItems: SidebarItem[] = []
  currentLang: string = 'ar';
  
  constructor(private translate: TranslateService, private authService: AuthService, private tourService: TourService) {}
  ngOnInit() {
    this.currentLang = this.translate.getDefaultLang() || 'ar';
    this.translate.onLangChange.subscribe((event) => {
      this.currentLang = event.lang;
      this.getSideMenuItems();
    });
  }
  
  getSideMenuItems() {
    this.sidebarItems = [
      { title: 'home', icon: 'pi pi-home', link: '/home' },
      { title: 'orders', icon: 'pi pi-inbox', link: '/orders' },
      { title: 'products', icon: 'pi pi-tag', link: '/products' },
      { title: 'payouts', icon: 'pi pi-money-bill', link: '/payouts' },
      { title: 'invoices', icon: 'pi pi-wallet', link: '/invoices' },
      { title: 'settings', icon: 'pi pi-cog', link: '/settings' },
      { title: 'startTour', icon: 'pi pi-compass', action: () => this.tourService.restartTour() },
      { title: 'logout', icon: 'pi pi-sign-out', action: () => this.logout(), danger: true },
      {
        title: `${this.currentLang === 'en'? 'arabic': 'english'}`,
        icon:'pi pi-language',
        action: () => this.switchLanguage(this.currentLang === 'en' ? 'ar' : 'en')
      }
    ];
    return this.sidebarItems;
  }

    // Switch language and update the layout direction
    switchLanguage(language: string) {
      this.currentLang = language;
      this.translate.use(language);
      this.translate.setDefaultLang(language);
      localStorage.setItem('language', language);
  
      const html: HTMLHtmlElement = document.getElementsByTagName('html')[0];
      if (html) {
        const langDir = language === 'ar' ? 'rtl' : 'ltr';
        html.classList.remove('rtl', 'ltr');
        html.dir = langDir;
        html.classList.add(langDir);
      }
    }

    logout() {
      this.authService.logout();
    }
}
